<template>
  <div
    class="flex items-center justify-between w-full px-4 py-3 font-medium rounded-md bg-theme-100 text-md">
    <label
      :for="disabled ? 'checkbox-disabled-' + question.id : 'checkbox-' + question.id"
      class="">
      {{ question.title }}
    </label>
    <input
      :id="disabled ? 'checkbox-disabled-' + question.id : 'checkbox-' + question.id"
      type="checkbox"
      :value="boolValue"
      v-model="boolValue"
      :disabled="disabled"
      :name="disabled ? 'checkbox-disabled-' + question.id : 'checkbox-' + question.id"
      class="w-6 h-6 accent-theme-500" />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import type { QstQuestionDetails } from '@/types/Questionnaires';

const data = defineModel<string>({ default: '' });
const boolValue = ref(false);

withDefaults(
  defineProps<{
    question: QstQuestionDetails;
    disabled?: boolean;
  }>(),
  {
    disabled: false,
  }
);

watch(
  boolValue,
  (newValue) => {
    const checkBoolValue = newValue ? '1' : '';
    if (data.value !== checkBoolValue) data.value = checkBoolValue;
  },
  { immediate: true }
);

watch(
  data,
  (newValue) => {
    const checkData = newValue.trim() === '1';
    if (boolValue.value !== checkData) boolValue.value = checkData;
  },
  { immediate: true }
);
</script>
